import { anySignal } from 'any-signal';
function filter(signals) {
  return signals.filter(Boolean);
}
export function abortSignal(...signals) {
  return anySignal(filter(signals));
}